module.exports = __webpack_public_path__ + "static/media/teninten.cca1ba16.jpg";